import { type Social } from '~/domains/core';
import { useGetDataByDomain } from '~/infrastructure';

export default (): Social[] => {
  const { getSocialData } = useGetDataByDomain();

  return getSocialData();
};
